import apiClient from 'apiClient';
import { Investment as API, InvestmentId as Id } from './Investment';
import { Investment as Domain } from 'modules/cm/RepaymentStrategy/Investment';
import { mapPartialDomainToPartialApi } from './mapper';

const update = async (apiPrefix: string, id: Id, property: Partial<Domain>): Promise<void> => {
  await apiClient.patch<API>(`${apiPrefix}/${id}`, mapPartialDomainToPartialApi(property));
};

export default update;
